{
  "en": {
    "answers": [
      {
        "id": 1328462,
        "text": "free market economy, social justice, state protection (Correct)",
        "is_right": true
      },
      {
        "id": 1328463,
        "text": "planned economy, price controls, bureaucracy (Incorrect)",
        "is_right": false
      },
      {
        "id": 1328464,
        "text": "central administration, lack of competition, conformity (Incorrect)",
        "is_right": false
      },
      {
        "id": 1328465,
        "text": "state monopolies, supply and demand, isolation (Incorrect)",
        "is_right": false
      }
    ],
    "tags": [
      {
        "id": 156068,
        "name": "Sample Question"
      },
      {
        "id": 156075,
        "name": "Gap-fill questions"
      }
    ],
    "text": "The social market economy combines the principles of \\_\\_\\_ with the goal of \\_\\_\\_ and \\_\\_\\_.",
    "display_in_order": true,
    "is_poll_question": false,
    "type": 2,
    "created_at": "2025-09-02T14:49:24.000Z",
    "created_by": "407c2236-d02c-4f64-abb4-bf31cda99416",
    "updated_at": "2025-09-03T08:55:21.000Z",
    "updated_by": "407c2236-d02c-4f64-abb4-bf31cda99416",
    "weblink": "https://quizacademy.de/tipps/#Tipps%20f%C3%BCr%20Quizfragen",
    "has_weblink": true,
    "explanation": "**Correct Answer:**\n* free market economy, social justice, state protection (Correct)\n\n**Further Information:**\n\nThe social market economy is based on the mechanisms of the **free market economy** (e.g., supply and demand), but is complemented by measures for **social justice** and **state protection**. This aims to secure prosperity and participation for broad sections of the population.\n\n**Notes:**\n\n* Gap-fill questions are ideal for testing key terms or principles.\n* In single-choice gap-fill questions, learners choose the correct completion from several options.\n* Short, precise answers and distractors that are thematically close increase the learning effect.\n\nGap-fill questions encourage active recall and are a useful addition to single-choice or multiple-choice questions. Ensure the blanks are clearly formulated and not ambiguous. Short sentences with precise keywords make it easier for learners to grasp the context.",
    "has_explanation": true,
    "num_answers": 4
  },
  "de": {
    "answers": [
      {
        "id": 1329030,
        "text": "freien Marktwirtschaft, sozialen Gerechtigkeit, staatlichen Absicherung (Richtig)",
        "is_right": true
      },
      {
        "id": 1329031,
        "text": "Planwirtschaft, Preisbindung, Bürokratie (Falsch)",
        "is_right": false
      },
      {
        "id": 1329032,
        "text": "Zentralverwaltung, Wettbewerbslosigkeit, Gleichschaltung (Falsch)",
        "is_right": false
      },
      {
        "id": 1329033,
        "text": "Staatsmonopole, Angebot und Nachfrage, Abschottung (Falsch)",
        "is_right": false
      }
    ],
    "tags": [
      {
        "id": 9427,
        "name": "Musterfrage"
      },
      {
        "id": 156079,
        "name": "Lückentext"
      }
    ],
    "text": "Die soziale Marktwirtschaft verbindet die Prinzipien der \\_\\_\\_ mit dem Ziel der \\_\\_\\_ und der \\_\\_\\_.",
    "display_in_order": true,
    "is_poll_question": false,
    "type": 2,
    "created_at": "2025-09-03T08:00:33.000Z",
    "created_by": "407c2236-d02c-4f64-abb4-bf31cda99416",
    "updated_at": "2025-09-03T08:17:33.000Z",
    "updated_by": "407c2236-d02c-4f64-abb4-bf31cda99416",
    "weblink": "https://quizacademy.de/tipps/#Tipps%20f%C3%BCr%20Quizfragen",
    "has_weblink": true,
    "explanation": "**Korrekte Antwort:**\n* freien Marktwirtschaft, sozialen Gerechtigkeit, staatlichen Absicherung (Richtig)\n\n**Weiterführende Informationen:**\n\nDie soziale Marktwirtschaft basiert auf den Mechanismen der **freien Marktwirtschaft** (z. B. Angebot und Nachfrage), wird aber durch Maßnahmen zur **sozialen Gerechtigkeit** und eine **staatliche Absicherung** ergänzt. So sollen Wohlstand und Teilhabe breiter Bevölkerungsschichten gesichert werden.\n\n**Hinweise:**\n\n* Lückentextfragen eignen sich ideal, um zentrale Begriffe oder Prinzipien abzufragen.\n* Bei Single-Choice-Lückentexten wählt man aus mehreren Antwortmöglichkeiten die richtige Ergänzung.\n* Kurze, prägnante Antworten und thematische Nähe der falschen Optionen erhöhen den Lerneffekt.\n\nLückentextfragen eignen sich besonders, um gezielt **Begriffe, Definitionen oder Prinzipien** abzufragen. Sie fördern aktives Erinnern und sind eine gute Ergänzung zu Single-Choice- oder Multiple-Choice-Fragen. Achte darauf, dass die Lücken klar formuliert und nicht mehrdeutig sind. Optimal sind kurze Sätze mit prägnanten Schlüsselbegriffen, sodass die Lernenden den inhaltlichen Zusammenhang leicht erfassen können.",
    "has_explanation": true,
    "num_answers": 4
  }
}
